import type { CSS } from '@stitches/react';
import React from 'react';

import { Text } from '@/components/shared/element/text';
import { Grid } from '@/components/shared/layout/grid';
import { styled } from '@/stitches.config';

const ContentItemStyled = styled(Grid, {
  px: '$space-0',
  '@md': {
    px: '$space-4',
  },
});

export interface ContentItemProps {
  css?: CSS;
  title: string;
  value: string | string[];
  test?: string;
}

export const ContentItem: React.FC<ContentItemProps> = ({
  css,
  title,
  value,
  test,
}: ContentItemProps) => {
  return (
    <ContentItemStyled rowGap="1" test={test} css={css}>
      <Text size="text-body-2" font="bold" variant="text-gray-dark">
        {title}
      </Text>
      {Array.isArray(value) ? (
        value.map((val, index) => (
          <Text
            key={index}
            size="text-body-2"
            variant="text-gray-darkest"
            dangerouslySetInnerHTML={{ __html: val }}
          />
        ))
      ) : (
        <Text
          size="text-body-2"
          variant="text-gray-darkest"
          dangerouslySetInnerHTML={{ __html: value }}
        />
      )}
    </ContentItemStyled>
  );
};

ContentItem.displayName = 'ContentItem';
